import { View } from 'react-native';
import { BaseButton } from '@photosi/rn-components/buttons/base-button/BaseButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { ColorToolPaletteStyle, styles } from './ColorToolOption.styles';
import { ColorToolOptionProps } from './ColorToolOption.types';
import { generateSelectedTestID, generateTestID, lookupChoiceTestID } from 'src/helpers/testIDs.helper';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { ToolOptionTooltip } from '../../../tool-option-tooltip/ToolOptionTooltip';
import { TestIDs } from 'src/constants/testIDs.constants';

export const ColorToolOption = ({
  index,
  isActive,
  isSelected,
  isDisabled,
  onPress,
  optionCode,
  color,
  title,
  hint,
  testID = lookupChoiceTestID(optionCode, index),
}: ColorToolOptionProps) => {
  const buttonTestID = generateSelectedTestID(testID, isSelected);

  return (
    <ToolOptionTooltip hint={hint}>
      <BaseButton
        style={styles.button}
        innerStyle={styles.buttonInner}
        focusStyle={styles.buttonFocus}
        testID={buttonTestID}
        onPress={onPress}
        focusId={buttonTestID}
        focusOrder={index}
        focusGroup={FocusGroups.TOOLBAR_OPTIONS}
        focusable={isActive}
        disabled={isDisabled}
        accessibilityRole="button"
        accessibilityLabel={title ?? `color tool option ${buttonTestID}`}
        accessible={true}
      >
        {() => {
          const colorStyle = color && ColorToolPaletteStyle[color];

          return (
            <>
              <View
                testID={generateTestID(buttonTestID, TestIDs.COLOR_WRAPPER)}
                style={[
                  styles.circularColorWrapper,
                  isSelected && styles.circularColorWrapperActive,
                  isDisabled && styles.circularColorWrapperDisabled,
                ]}
              >
                {colorStyle ? (
                  <View style={[styles.circularColor, colorStyle]} />
                ) : (
                  <Icon
                    width={styles.circularColor.width}
                    height={styles.circularColor.height}
                    name={ICON_NAMES.NoColor}
                  />
                )}
              </View>
              {title && (
                <TextLato
                  testID={generateTestID(buttonTestID, TestIDs.TITLE)}
                  style={[
                    styles.textColor,
                    isSelected && styles.textColorActive,
                    isDisabled && styles.textColorDisabled,
                  ]}
                >
                  {title}
                </TextLato>
              )}
            </>
          );
        }}
      </BaseButton>
    </ToolOptionTooltip>
  );
};

ColorToolOption.displayName = 'ColorToolOption';
